import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, convertObjectToArray, importCSS } from '../../lib/ep.js';
import { size as _size } from 'lodash';
import { sweep as const_sweep } from './bootstrap';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import ConfirmButton from '../builder/ConfirmButton';
import Input from '../builder/Input';
import SaveButton from '../builder/SaveButton';

const Wrapper = (props) => {
	const title = (props.title != undefined && props.title != '') ? props.title : false;
	const organizer = (props.organizer != undefined && props.organizer != '') ? props.organizer : false;

	const extra_classes = (props.extra_classes != undefined) ? ' ' + props.extra_classes : '';

	return (
		<section class="gui_live_contest is_manager" style={{background:props.main_color}}>
			<div style={{width:'100%', display:'flex', flexGrow:'1'}}>
				<article class={'contents' + extra_classes}>
					{props.children}
				</article>
			</div>

			{(title || organizer) && (
				<footer class="footer" style={{width:'100%'}}>
					{(title) && (
						<h1 class="title gui_cutTextOnOverflow gui_text_align_center" style={{maxWidth:'calc(100% - 30px)'}}>{title}</h1>
					)}
				</footer>
			)}
		</section>
	)
}

const RoundedButton = (props) => {
	var Component = null;
	switch(props.component_type) {
		case 'save':
			Component = SaveButton;
			break;
		case 'link':
			Component = ActionLink;
			break;
		case 'confirm':
			Component = ConfirmButton;
			break;
		case 'button':
		default:
			Component = ActionButton;
			break;
	}

	var new_props;
	if(props.main_color != undefined) {
		new_props = {...props, color:'variable', _class:{...props._class}, style:{background:props.main_color}};
	} else {
		new_props = {...props, color:'black', _class:{...props._class}};
	}

	new_props.component_type = null;
	new_props.children = null;

	return (
		<div class="gui_rounded_bordered_button">
			<Component {...new_props}>{props.children}</Component>
		</div>
	)
}

let hidden = null;
let visibilityChange = null;
if(typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
	hidden = 'hidden';
	visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
	hidden = 'msHidden';
	visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
	hidden = 'webkitHidden';
	visibilityChange = 'webkitvisibilitychange';
}

class SweepsLiveProjectionManage extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = props.params_state;
		this.state.total_projection_connected = 0;
		this.state.total_finalists = 0;

		this.total_projection_connected = 0;
		this.has_admin_manual_started = false;
		this.has_contest_finished = true;

		this.reaction_gifs = (props.reaction_gifs != undefined) ? props.reaction_gifs : false;
	}

	componentWillMount() {
		importCSS('comp/live_contest.css');
	}

	componentDidMount() {
		const values = this.state.values;
		var socket = io(window.socket_url);
		this.socket = socket;
		this.socket.on('connect', () => {
			//Now try to join to the promotion room
			this.socket.emit('join_sweep',{sweep_id:values.id});
			this.socket.emit('live_sweep',{sweep_id:values.id,action:'check_connections'});

			this.socket.on('rooms',(rooms)=>{
				if(rooms.sockets!=undefined){
					var total_connected = 0;
					for (var id  in rooms.sockets) {
						if(this.socket.id!=id){
							total_connected++;
						}
					}
					this.setState({total_projection_connected:total_connected})
				}
			});

			if(window.location.hash == '#manage'){
				this.socket.on('live_sweep', (data) => {
					if(data.action == 'stop_manage') {
						this.manage_actions({type:data.action});
					}

					if(data.action == 'gif_to_manage') {
						this.setState({ display_gif:data.value });
					}
				});
			}
		});
		this.totalFinalists();

		document.addEventListener(visibilityChange, this.handleVisibilityChange, false);
	}

	handleVisibilityChange = () => {
		if (document[hidden]) {
			//alert('OFF')
		} else {
			const values = this.state.values;
			if(values.end && values.end <= values.now){
				this.manage_actions({type:'get_times'})
			}
		}
	}

	totalFinalists() {
		const sweep_id = this.state.values.id;
		var data = {};
		data.action = 'total_finalists';
		$.post('/action/' + sweep_id + '/' + data.action, data, (response) => {
			if(response.status) {
				this.state.total_finalists = response.total;
				this.setState({...this.state});
			}
		}, 'json');
	}

	changeManage(k, v) {
		this.state.manage[k] = v;
		this.setState({...this.state});
	}

	manage_actions(values, cb) {
		//EMIT Actions
		const sweep_id = this.state.values.id;

		switch(values.type) {
			case 'zoom_qr':
				this.state.manage.gif = false;
				this.state.manage.qr_zoomed_in = !this.state.manage.qr_zoomed_in;
				this.setState({...this.state});
				this.socket.emit('live_sweep', { sweep_id:sweep_id, action:'toogle_qr' });
				if(cb != undefined) cb();
				break;
			case 'gif':
				this.state.manage.qr_zoomed_in = false;
				this.state.manage.gif = (this.state.manage.gif === false || this.state.manage.gif != values.mode) ? values.mode : false;
				if(this.state.manage.gif === false) this.state.display_gif = false;
				this.setState({...this.state});
				this.socket.emit('live_sweep', { sweep_id:sweep_id, action:'gif', mode:this.state.manage.gif });
				if(cb != undefined) cb();
				break;
			case 'stop_manage':
				this.totalFinalists();
				this.state.manage.stopped_from_projector = true;
				this.setState({...this.state});
				break;
			case 'stop':
				this.state.manage.stopped_from_projector = true;//Not Projector but same action
				this.socket.emit('live_sweep', { sweep_id:sweep_id, action:'stop' });
				this.totalFinalists();
				break;
			case 'start':
				this.has_admin_manual_started = true;
				this.socket.emit('live_sweep', { sweep_id:sweep_id, action:'start' });
				break;
			case 'stats':
				this.state.manage.stats = true;
				this.setState({...this.state});
				this.socket.emit('live_sweep', { sweep_id:sweep_id, action:'stats' });
				if(cb != undefined) cb();
				break;
			case 'ranking':
				this.state.manage.show_ranking = true;
				if(parseInt(this.state.total_finalists) < parseInt(this.state.values.total_winners)) {
					this.state.manage.done = true;
				}
				this.setState({...this.state});
				this.socket.emit('live_sweep', { sweep_id:sweep_id, action:'ranking' });
				if(cb != undefined) cb();
				break;
			case 'draw':
				this.state.manage.done = true;
				this.setState({...this.state});
				this.socket.emit('live_sweep', { sweep_id:sweep_id, action:'draw' });
				if(cb != undefined) cb();
				break;
			case 'cursor_stats':
				this.socket.emit('live_sweep', { sweep_id:sweep_id, action:'cursor_stats', index:values.index, display:values.display });
				this.state.manage.show_stats = (values.display) ? values.display : false;
				this.state.show_index_stats = values.index;
				this.setState({...this.state});
				if(cb != undefined) cb();
				break;
			case 'check_setup':
					var data = {};
					data.action = 'none';
					$.ajax({
						url:'/action/' + sweep_id + '/' + data.action,
						data:data,
						async:true,
						dataType:'json',
						type:'POST',
						success:(response) => {
							this.state.values = response.values;
							this.setState({...this.state});
							if(cb != undefined) cb();
						}
					});
				break;
			case 'get_times':
				var start_time = new Date().getTime();
				var data = {};
				data.action = 'get_times';
				$.ajax({
					url:'/action/' + sweep_id + '/' + data.action,
					data:data,
					async:true,
					dataType:'json',
					type:'POST',
					success:(response) => {
						this.state.times.end = response.new_end_time;
						this.setState({...this.state});
						if(cb != undefined) cb();
					}
				});
				break;
			case 'login':
				var data = {};
					data.action = 'login';
					data.number = this.state.manage.logged_pin;
				$.ajax({
					url:'/action/' + sweep_id + '/' + data.action,
					data:data,
					async:true,
					dataType:'json',
					type:'POST',
					success:(response) => {
						this.state.manage.logged = response.logged;
						this.setState({...this.state});
						if(cb != undefined) cb();
					}
				});
				break;
		}

		if(values.type == 'start' || values.type == 'stop_manage') {
			var start_time = new Date().getTime();
			var data = {};
			data.action = 'get_times';
			setTimeout(() => {
				$.ajax({
					url:'/action/' + sweep_id + '/' + data.action,
					data:data,
					async:true,
					dataType:'json',
					type:'POST',
					success:(response) => {
						this.state.values = response.values;
						this.setState({...this.state});
						if(cb != undefined) cb();
					}
				});
			}, 1000);
		}
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const params_props = this.props.params_props;
		const values = this.state.values;

		var question_number = this.state.index_question;
		var actual_question = this.state.actual_question;

		const questions = (params_props.questions != undefined) ? params_props.questions : false;
		const has_questions = (questions && _size(questions) > 0) ? true : false;

		var has_ranking = false;
		questions.map((item, i) => {
			if(item.type == 'quiz') has_ranking = true;
		})

		const has_admin_manually_started = this.has_admin_manual_started;
		const has_contest_started = (!this.state.display_start_counter && values.start && !this.state.manage.stopped_from_projector) ? true : false;
		const has_contest_finished = (values.end && values.end <= values.now && this.state.manage.stopped_from_projector) ? true : false;

		const actual_show_index_stats = parseInt(this.state.show_index_stats);
		const next_show_index_stats = parseInt(actual_show_index_stats) + 1;
		const prev_show_index_stats = parseInt(actual_show_index_stats) - 1;

		var props_wrapper = {};
		props_wrapper.title = this.state.values.title;
		props_wrapper.organizer = this.state.values.organizer;
		props_wrapper.intl = this.props.intl;
		props_wrapper.main_color = this.state.values.main_color;

		if(this.state.total_projection_connected < 1) {
			return (
				<Wrapper {...props_wrapper} extra_classes="gui_flex_center">
					<div class="real_contents textual_contents">
						<p><strong>{i18n("The Main Screen URL is not open anywhere.")}</strong></p>
						<p>{i18n("Open it in the browser you are using for the projection and this will be enabled automatically.")}</p>
					</div>
				</Wrapper>
			)
		}

		if(!this.state.manage.logged) {
			return (
				<Wrapper {...props_wrapper} extra_classes="gui_flex_center">
					<div class="real_contents">
						<Input name="logged_pin" model={this.state.manage} change={(k, v) => this.changeManage(k, v)} placeholder="Remote Control key" _class={{first:true, other:'gui_big_input'}} />
					</div>

					<ButtonCollection type='aside' _class={{other:'gui_flex_col gui_full_width'}}>
						<RoundedButton component_type="save" onClick={(e, cb) => this.manage_actions({type:'login'}, cb)}>Login</RoundedButton>
					</ButtonCollection>
				</Wrapper>
			)
		}

		if(!has_admin_manually_started) {
			return (
				<Wrapper {...props_wrapper}>
					<div class="real_contents live_question">
						<ul class="question_answers">
							{(this.state.values.start && false) ? (
								<li>
									<div class="real_contents textual_contents">
										<p>{i18n("Sorry, the giveaway has already been initiated. Remote control is disabled.")}</p>
										<p>{i18n("You have to manage the giveaway from the computer projecting the screen.")}</p>
									</div>
								</li>
							) : (
								<li><RoundedButton component_type="save" onClick={(e, cb) => this.manage_actions({type:'start'}, cb)}>{((this.state.values.start) ? "Resume" : "Go live")}</RoundedButton></li>
							)}
						</ul>
					</div>
				</Wrapper>
			)
		}

		if(has_contest_finished && this.state.values.status != const_sweep.CLOSED && !this.state.manage.done) {
			const make_sweeps_label = (this.state.sweep.config.num_winners > 1) ? "AND THE WINNERS ARE" : "AND THE WINNER IS";

			const has_draw = (parseInt(this.state.total_finalists) >= parseInt(this.state.values.total_winners)) ? true : false;
			const in_last_question = (next_show_index_stats >= _size(questions)) ? true : false;
			const show_ranking_button = (this.state.manage.show_stats && in_last_question && has_ranking && !this.state.manage.show_ranking) ? true : false;
			const show_draw_button = (!has_questions || (in_last_question && this.state.manage.show_ranking && has_draw) || (!has_ranking && this.state.manage.show_stats && in_last_question)) ? true :false;
			const show_next_button = (this.state.manage.show_stats && next_show_index_stats < _size(questions) && has_questions && this.state.manage.stats) ? true :false;
			const show_graph_button = (!this.state.manage.show_stats && has_questions && this.state.manage.stats) ? true :false;
			const show_stats_button = (has_questions && !this.state.manage.stats) ? true : false;

			const actual_question_item = (questions != undefined && questions[next_show_index_stats - 1] != undefined) ? questions[next_show_index_stats - 1] : false;

			return (
				<div>
					<Wrapper {...props_wrapper}>
						<div class="real_contents live_question">
							<ul class="question_answers">
								{(show_stats_button) && (
									<li>
										<p class="button_extra_message">{i18n("Time is over!")}</p>

										<RoundedButton
											onClick={(e, cb) => this.manage_actions({type:'stats'}, cb)}
										>NEXT</RoundedButton>
									</li>
								)}

								{(show_graph_button) && (
									<li>
										{(actual_question_item) && (
											<p class="button_extra_message">{actual_question_item.text}</p>
										)}

										<RoundedButton
											onClick={(e, cb) => this.manage_actions({type:'cursor_stats', index:actual_show_index_stats, display:true}, cb)}
										>View results</RoundedButton>
									</li>
								)}

								{(show_next_button) && (
									<li>
										{(actual_question_item) && (
											<p class="button_extra_message">{actual_question_item.text}</p>
										)}

										<RoundedButton
											component_type="save"
											onClick={(e, cb) => this.manage_actions({type:'cursor_stats',index:next_show_index_stats},cb)}
										>NEXT</RoundedButton>
									</li>
								)}

								{(show_ranking_button) && (
									<li>
										{(actual_question_item) && (
											<p class="button_extra_message">{actual_question_item.text}</p>
										)}
										<RoundedButton
											component_type="save"
											onClick={(e, cb) => this.manage_actions({type:'ranking'},cb)}
										>Ranking</RoundedButton>
									</li>
								)}

								{(show_draw_button) && (
									<li>
										<RoundedButton
											component_type="save"
											onClick={(e, cb) => this.manage_actions({type:'draw'},cb)}
											autotranslate={false}
										>{i18n(make_sweeps_label) + '...'}</RoundedButton>
									</li>
								)}
							</ul>
						</div>
					</Wrapper>
				</div>
			)
		}

		if(!this.state.manage.done) {
			const avail_gifs = (this.reaction_gifs) ? convertObjectToArray(this.reaction_gifs) : false;

			return (
				<div>
					<Wrapper {...props_wrapper}>
						<div class="real_contents live_question">
							<ul class="question_answers">
								<li><RoundedButton onClick={() => this.manage_actions({type:'zoom_qr'})} autotranslate={false}>{(!this.state.manage.qr_zoomed_in) ? i18n("QR Zoom IN") : i18n("QR Zoom OUT")}</RoundedButton></li>

								{(avail_gifs) && (
									<li>
										<ul class="question_answers gif_controls">
											<li class="gui_preview knk-animated-gif">
												{(this.state.display_gif) && (
													<img src={this.state.display_gif} height="100%" />
												)}
											</li>

											{avail_gifs.map((gif_collection, g) => {
												return (
													<li key={g}>
														<RoundedButton
															onClick={() => this.manage_actions({type:'gif', mode:gif_collection.key})}
															autotranslate={false}
														>{(this.state.manage.gif == gif_collection.key) ? i18n("Hide GIF") : i18n("Display GIF for") + " " + i18n(gif_collection.key, 'ucfirst')}</RoundedButton>
													</li>
												)
											})}
										</ul>
									</li>
								)}
							</ul>

							<ConfirmButton
								color="red"
								_position="top"
								onClick={(e, cb) => this.manage_actions({type:'stop'}, cb)}
							>Finish manually</ConfirmButton>
						</div>
					</Wrapper>
				</div>
			)
		}

		if(this.state.manage.done) {
			return (
				<div>
					<Wrapper {...props_wrapper}>
						<div class="real_contents textual_contents">
							<p class="icon knk-crown in_bottom" />
							<p class="in_bottom"><strong>{i18n("Done!")}</strong></p>
							<p>{i18n("There are no more actions to do.")}</p>
							<p>{i18n("Enjoy your moment.")}</p>
							<p>{i18n("You became the King of Easypromos Live!")}</p>
						</div>
					</Wrapper>
				</div>
			)
		}
	}
}

export default injectIntl(SweepsLiveProjectionManage);